var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"m-icon-stroke-color",attrs:{"width":"28","height":"29","viewBox":"0 0 28 29","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('rect',{attrs:{"width":"24","height":"4","rx":"1","transform":"matrix(1 0 0 -1 2 16.2861)","fill":"#5A55F4"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }